import { createRouter, createWebHistory } from 'vue-router'
import ClearPage from "@/components/ClearPage.vue";
import AdvancedSelect from "@/components/demo/advanced-select/AdvancedSelect.vue";
import Tooltip from "@/components/demo/tooltip/Tooltip.vue";
import Login from "@/components/user/login/Login.vue";
import Balance from "@/components/billing/balance/Balance.vue";
import Invoice from "@/components/billing/invoice/Invoice.vue";
import ObjectMonitoring from "@/components/object/monitoring/ObjectMonitoring.vue";
import TextField from "@/components/demo/text-field/TextField.vue";
import Debtors from "@/components/billing/debtors/Debtors.vue";
import Textarea from "@/components/demo/textarea/Textarea.vue";
import Modal from "@/components/demo/modal/Modal.vue";
import Company from "@/components/company/Company.vue";
import TokenLogin from "@/components/user/tokenLogin/TokenLogin.vue";
import RadioField from "@/components/demo/radio-field/RadioField.vue";
import SubscribePaid from "@/components/billing/subscribe/paid/Paid.vue";
import Subscribe from "@/components/billing/subscribe/payment/StripeForm.vue";
import ObjectPaid from "@/components/object/objectPaid/ObjectPaid.vue";
import SwitchField from "@/components/demo/switch-field/SwitchField.vue";
import NumberField from "@/components/demo/number-field/NumberField.vue";
import DatePickerField from "@/components/demo/datePicker-field/DatePickerField.vue";
import TableField from "@/components/demo/table-field/TableField.vue";
import CheckboxField from "@/components/demo/checkbox-field/CheckboxField.vue";
import store from '../../store'

const routes = [
    {
        path: '/login',
        name: 'menu.user.login',
        component: Login,
        meta: { public: true, isMenuItem: false, icon: 'bi bi-person', title: 'general.title.login' }
    },
    {
        path: '/token/:token',
        name: 'menu.user.loginToken',
        component: TokenLogin,
        meta: { public: true, isMenuItem: false, icon: 'bi bi-person' }
    },
    {
        path: '/billing/balance',
        name: 'menu.billing.balance.title',
        component: Balance,
        icon: 'bi bi-currency-euro',
        meta: { public: false, isMenuItem: true, permissions: '2069ca795d8e10a6f9a92dd57d01af10', title: 'general.title.balance' }
    },
    {
        path: '/billing/invoices',
        name: 'menu.billing.invoices.title',
        component: Invoice,
        icon: 'bi bi-files-alt',
        meta: { public: false, isMenuItem: true, permissions: '56deca22a707214865f7ea3ae6391d67', title: 'general.title.invoice' }
    },
    {
        path: '/stripe/subscribe/paid/:token',
        name: 'menu.billing.subscribePaid.title',
        component: SubscribePaid,
        icon: 'bi bi-files-alt',
        meta: { public: false, isMenuItem: false, permissions: '56deca22a707214865f7ea3ae6391d67' }
    },
    {
        path: '/stripe/object/paid/:token',
        name: 'menu.billing.paid.title',
        component: ObjectPaid,
        icon: 'bi bi-files-alt',
        meta: { public: false, isMenuItem: false, permissions: '9a152d364b2887cdca803e6b3990449b' }
    },
    {
        path: '/object/monitoring',
        name: 'menu.object.monitoring.title',
        component: ObjectMonitoring,
        icon: 'bi bi-pin-map',
        meta: { public: false, isMenuItem: true, permissions: 'a5ea1ee06cf8282e3d7adf855a67f756', title: 'general.title.objectMonitoring' }
    },
    {
        path: '/billing/subscribe',
        name: 'menu.billing.payment.title',
        component: Subscribe,
        icon: 'bi bi-credit-card',
        meta: { public: false, isMenuItem: true, permissions: 'c453a4b8e8d98e82f35b67f433e3b4da', title: 'general.title.subscribe' }
    },
    {
        path: '/billing/debtors',
        name: 'menu.billing.debtors.title',
        component: Debtors,
        icon: 'bi bi-cash-coin',
        meta: { public: false, isMenuItem: true, permissions: '1cd7007fdac4d6053b622c1825a5382f', title: 'general.title.debtors', section: 'ADMIN' }
    },
    {
        path: '/company',
        name: 'menu.client.title',
        component: Company,
        icon: 'bi bi-person-circle',
        meta: { public: false, isMenuItem: true, permissions: 'b08c3afe8da4b0a123f2717134017423', title: 'general.title.company', section: 'ADMIN' }
    },
    {
        path: '/component',
        title: 'menu.demo.title',
        component: ClearPage,
        icon: 'bi bi-tools',
        meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', title: 'general.title.component', section: 'ADMIN' },
        children: [
            {
                path: '',
                meta: { isMenuItem: false, permissions: '700c216fb376666eaeda0c892e8bdc09' },
                redirect: { name: 'menu.demo.advancedSelect' }
            },
            {
                path: 'advanced-select',
                name: 'menu.demo.advancedSelect',
                component: AdvancedSelect,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'tooltip',
                name: 'menu.demo.tooltip',
                component: Tooltip,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'table-field',
                name: 'menu.demo.tableField',
                component: TableField,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'checkbox-field',
                name: 'menu.demo.checkboxField',
                component: CheckboxField,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'radio-field',
                name: 'menu.demo.radioField',
                component: RadioField,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'text-field',
                name: 'menu.demo.textField',
                component: TextField,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'number-field',
                name: 'menu.demo.numberField',
                component: NumberField,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'switch-field',
                name: 'menu.demo.switchField',
                component: SwitchField,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'textarea',
                name: 'menu.demo.textarea',
                component: Textarea,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'date-picker',
                name: 'menu.demo.datePicker',
                component: DatePickerField,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            },
            {
                path: 'modal',
                name: 'menu.demo.modal',
                component: Modal,
                meta: { public: false, isMenuItem: true, permissions: '700c216fb376666eaeda0c892e8bdc09', parentPath: '/component', isConfigPage: false }
            }
        ]
    },
];

const router = new createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(async(to, from, next) => {
    await store.dispatch('checkPermission');

    if (to.matched.length === 0) {
        next({ path: '/login' });
    } else {
        if (!sessionStorage.getItem("accessToken") && !to.meta.public) {
            next({ path: '/login' });
        } else if (sessionStorage.getItem("accessToken") && to.meta.public) {
            next({ path: '/billing/balance' });
        } else {
            if (!to.meta.public) {
                const allowed = store.getters.hasPermission(to.meta.permissions);
                if (to.meta.permissions === null || allowed) {
                    next();
                } else {
                    next({ path: '/billing/balance' });
                }
            } else {
                next()
            }
        }
    }
})
export default router;